import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LoadingColor, LoadingType } from '@constants/loading/1.0';
import { NgClass } from '@angular/common';

@Component({
  selector: 'txp-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  host: { class: 'txp-loading' },
  standalone: true,
  imports: [NgClass],
})
export class LoadingComponent implements OnChanges {
  @Input() color: LoadingColor = LoadingColor.DEFAULT;
  @Input() type: LoadingType = LoadingType.DEFAULT;
  classes;

  ngOnChanges(changes: SimpleChanges): void {
    this.classes = `${this.color} ${this.type}`;
  }
}
